
const API_KEY = process.env.REACT_APP_SCRIPTURE_API_KEY || "";

export default API_KEY;
